import { travelTypeObject } from '../../enumeration';
import { PATH_DASHBOARD } from '../../routes/paths';
import api from '../../services/api';

const EVisitorManagement = {
  title: 'مدیریت سفر',
  routes: PATH_DASHBOARD.course,
  api: api.travel,
  enum: {
    array: Object.values(travelTypeObject),
    object: travelTypeObject,
  },
};

export default EVisitorManagement;
